import React, { Component } from 'react';
import MyOrderDetailView from './MyOrderDetailView';

function MyOrderDetailController(props) {
    return (
        <MyOrderDetailView
            open={props.open}
            onClose = {props.onClose}
            order={props.order}
            currency={props.currency}/>
    );
}

export default MyOrderDetailController;